/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
/* global, Office, self, window */

Office.onReady(() => {
    // If needed, Office.js is ready to be called
});
